import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

/**
 * Wrap a route that should be available only to specific roles.
 * Other roles get redirected to "/" (their home).
 */
export default function RoleGuard({ allow, children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!allow.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
